import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService } from "../services/api";

const BlogRanduTagsPage = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await randuBlogService.listTags();
      if (res.success) setItems(res.items || []);
    })();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Randu.app Blog — Etiketler" />
      <p className="text-muted small">
        Etiketler yazı düzenlerken virgülle eklenir; burada salt okunur liste (slug çakışmalarını görmek için).
      </p>
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Slug</th>
                  <th>Ad</th>
                </tr>
              </thead>
              <tbody>
                {items.map((t) => (
                  <tr key={t.id}>
                    <td>{t.id}</td>
                    <td>
                      <code>{t.slug}</code>
                    </td>
                    <td>{t.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduTagsPage;
